import { translate as tr } from "../translations";

/**
 * Ünvan ilerlemesinin ortak biçimi. Sunucu her ünvanda birincil şartı
 * (unit, threshold, value, remaining) ve 10. seviyede ikinci şartı (also,
 * hep "hafta") gönderir. Eşikler sunucudan gelir, burada sabit eşik yok.
 * Haftalık şart "9 / 12 hafta üst üste"; dakika birimi saate çevrilir.
 */

const hours = (minutes) =>
  (Math.round(((Number(minutes) || 0) / 60) * 10) / 10).toLocaleString("tr-TR", { maximumFractionDigits: 1 });
const count = (n) => (Number(n) || 0).toLocaleString("tr-TR");

/** Ünvanın birincil birimi: ünvandaki unit, yoksa ailenin birimi. */
export function titleUnit(title, fallbackUnit) {
  return title?.unit || fallbackUnit || "";
}

/** Tek bir miktar ve birimi: dakika saate, diğerleri olduğu gibi. */
export function amountText(value, unit) {
  if (unit === "dakika") return `${hours(value)} ${tr("titles_unit_hours")}`;
  return `${count(value)} ${unit || ""}`.trim();
}

/** Şart listesi: birincil ve (varsa) ikinci şart. */
export function titleConditions(title, fallbackUnit) {
  if (!title) return [];
  const list = [
    {
      metric: title.metric,
      unit: titleUnit(title, fallbackUnit),
      value: Number(title.value) || 0,
      threshold: Number(title.threshold) || 0,
      remaining: title.remaining,
    },
  ];
  if (title.also) {
    list.push({
      metric: title.also.metric,
      unit: title.also.unit || "hafta",
      value: Number(title.also.value) || 0,
      threshold: Number(title.also.threshold) || 0,
      remaining: title.also.remaining,
    });
  }
  return list;
}

/** Şartın oranı (0..1). */
export function conditionRatio(condition) {
  if (!condition || condition.threshold <= 0) return 0;
  return Math.min(1, condition.value / condition.threshold);
}

/** "120 / 150 müzakere", "9 / 12 hafta üst üste", "1,5 / 3 saat". */
export function conditionText(condition) {
  const { value, threshold, unit } = condition;
  if (unit === "dakika") return `${hours(value)} / ${hours(threshold)} ${tr("titles_unit_hours")}`;
  if (unit === "hafta") return `${count(value)} / ${count(threshold)} ${tr("titles_weeks_in_a_row")}`;
  return `${count(value)} / ${count(threshold)} ${unit || ""}`.trim();
}

/** Kalan miktar: "3 hafta", "2 saat", "5 müzakere"; remaining yoksa eşikten. */
export function remainingText(condition) {
  const left =
    condition.remaining != null ? Number(condition.remaining) || 0 : Math.max(0, condition.threshold - condition.value);
  return amountText(left, condition.unit);
}

/** En az tamamlanmış şart (ilerleme çubuğu ve "kalan" buna göre). */
export function limitingCondition(title, fallbackUnit) {
  const list = titleConditions(title, fallbackUnit);
  if (!list.length) return null;
  return list.reduce((min, c) => (conditionRatio(c) < conditionRatio(min) ? c : min), list[0]);
}

/** İlerleme oranı (0..1): şartların en az tamamlanmışı. */
export function titleRatio(title) {
  const limiting = limitingCondition(title);
  return limiting ? conditionRatio(limiting) : 0;
}
